export enum ConsultationViewTypes {
  Open = 1,
  Archived = 2,
}
